export type ProductType = 'IMT' | 'PAC' | 'PPC' | 'MTR';

export const ProductTypes = { IMT: 'IMT', PAC: 'PAC', PPC: 'PPC', MTR: 'MTR' } as const;
export const PartnershipTypes = { IN2: 'IN2', MIC: 'MIC', BUS: 'BUS' } as const;
